import { CheckoutState } from '../state/initial-state';

export const checkoutLoaded: WtrReducer<CheckoutState, undefined> = state => {
  return {
    ...state,
    checkoutLoaded: true,
  };
};
